import HttpKit from '@/utils/http-kit'

export default {

  /**
   * 采购需求
   * /portalCli/bidNeed
   * @param keyword  关键字
   * @param current 当前页
   * @param size 每页记录数(默认每页10条)
   * @param procurementType 采购内容A：通用设备；D科研仪器；E实验试剂；F耗材；B工程；C服务；G租售
   * @param sourceType C：学校的订单，E：企业的订单，O 事业单位；H:医疗机构；S：科研机构
   * @param collegeName 单位所在地
   * @param areaScope 所在区域（01华南；02华北；03华东；04华中；05西北；06东北；07西南；08东南）
   */
  bidNeed (keyword, current, size, procurementType, sourceType, collegeNameList, areaScope) {
    return HttpKit.post('/api/portalCli/bidNeed', {
      keyword: keyword,
      current: current,
      size: size,
      condition: {
        areaScope: areaScope,
        procurementType: procurementType,
        sourceType: sourceType,
        collegeNameList: collegeNameList
      }
    }).then(
      res => res.data
    )
  },

  /**
   * 最新推荐
   * /portalCli/bidNeed/recommend
   * @param keyword  关键字
   * @param current 当前页
   * @param size 每页记录数(默认每页10条)
   */
  recommend (keyword, current, size) {
    return HttpKit.post('/api/portalCli/bidNeed/recommend', {
      keyword: keyword,
      current: current,
      size: size
    }).then(
      res => res.data
    )
  },

  /**
   * 采购需求明细
   * /portalCli/bidResult/detail
   * @param orderMainId 主单ID
   */
  detail (orderMainId) {
    return HttpKit.post('/api/portalCli/bidNeed/detail', {orderMainId: orderMainId}).then(
      res => res.data
    )
  }

}



// WEBPACK FOOTER //
// ./src/api/bidNeed.js